 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","1":"default~administration-administration-module~back-office-back-office-module~bglc-reports-bglc-report~a6fadaa5","2":"default~administration-administration-module~application-application-module~back-office-back-office-~7be3dca5","3":"default~application-application-module~back-office-back-office-module~bglc-reports-bglc-reports-modu~791c35c4","4":"default~back-office-back-office-module~bglc-reports-bglc-reports-module~blinksky-blinksky-module~con~d83bc84b","5":"default~application-application-module~back-office-back-office-module~bglc-reports-bglc-reports-modu~e9cf24de","6":"default~administration-administration-module~bglc-reports-bglc-reports-module~horse-racing-horse-rac~fb3ca379","7":"default~application-application-module~back-office-back-office-module~consumer-consumer-module~finte~55339e2e","8":"default~barcode-scanner-barcode-scanner-module~cashpot-game-cashpot-game-module~kiosk-blue-theme-kio~dc3c9b25","9":"default~cashpot-game-cashpot-game-module~consumer-consumer-module~games-games-module~kiosk-blue-them~7d5f6039","10":"default~back-office-back-office-module~consumer-consumer-module~reporting-reporting-module~svl-servi~beaad9fd","12":"default~back-office-back-office-module~referral-module-referral-module-module","13":"default~fintech-fintech-module~utilities-utilities-module","14":"default~kiosk-device-management-kiosk-device-management-module~ticket-payout-ticket-payout-module","15":"administration-administration-module","16":"application-application-module","17":"back-office-back-office-module","18":"bglc-reports-bglc-reports-module","19":"blinksky-blinksky-module","20":"cashpot-game-cashpot-game-module","21":"consumer-consumer-module","22":"edufocal-edufocal-module","23":"fintech-fintech-module","24":"games-games-module","25":"gli-reports-gli-reports-module","26":"guyana-reports-guyana-reports-module","27":"horse-racing-horse-racing-module","28":"icasino-reports-icasino-reports-module","29":"kiosk-blue-theme-kiosk-blue-theme-module","30":"kiosk-device-management-kiosk-device-management-module","31":"kiosk-kiosk-module","33":"mmg-reports-mmg-reports-module","34":"numbers-numbers-module","35":"panel-management-panel-management-module","36":"platform-configurations-platform-configurations-module","37":"platform-reports-platform-reports-module","39":"ready-credit-ready-credit-module","40":"referral-module-referral-module-module","41":"reporting-reporting-module","42":"reports-reports-module","44":"svl-services-svl-services-module","45":"ticket-payout-ticket-payout-module","46":"tickets-voids-tickets-voids-module","47":"voucher-voucher-module","48":"winning-list-winning-list-module","49":"winning-numbers-winning-numbers-module"}[chunkId]||chunkId) + "." + {"0":"c910e45c49c3a87ab37b","1":"a146b552473bf84ea65a","2":"ab2d26aaa11512d69a01","3":"15422e8342f90122c1a7","4":"fb1ab3151253c7d3d1a4","5":"66552c4beab722c4e908","6":"f56529d98341e2cf5a0b","7":"58259125ce04f02411f2","8":"e0c81496c1b6f98f2ee4","9":"82f47efaf57b74d0de39","10":"667cf2e80be7a4d6d8b5","12":"d2551d32a22b4a9f33e7","13":"0e9649720c83d23d89bd","14":"4c547199eaf9abb14fbb","15":"cb4043ef2417db8ba58f","16":"bb73e126e727d526840b","17":"408c1c2fb4daf88bd07d","18":"09f908d84a6366f4431a","19":"f19ea225868caf4209f5","20":"a53078a276243098096b","21":"0d7c14038419f345cde1","22":"c938b6bb0cef0481d007","23":"08157844662b671c3e78","24":"b69c51324e5f39daef14","25":"6e8699dd0fb7e34849d2","26":"df023b84ab1c1e63f6a0","27":"2ee101740ce036b8404f","28":"31d0e2251ba2bce34a63","29":"323539598f084e846ae3","30":"1808d294548060ab1640","31":"129169864c33649082db","33":"bc07c7db0918a04ea2a9","34":"aee713a5d2629347e264","35":"b8ee6c4a8df519d812d5","36":"3da4bd3c81baba342ff0","37":"216e1535716e5a33e987","39":"c76308d898e2931fa552","40":"ad627f16680b1d9cac23","41":"1c07994b776ff0db0fe6","42":"07c5700149fef1459860","44":"2d66b29b0a67a20e6b6b","45":"07c6a77fcf2a5087c233","46":"1a2395dd3dc13aa2dbcf","47":"c8ccc2343dd660747abd","48":"5b1a4c29accae4b11290","49":"ecd83120d13d5890c8ef"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
